"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var radio_1 = require('./radio');
var radio_2 = require('./radio');
exports.NgbRadio = radio_2.NgbRadio;
exports.NgbActiveLabel = radio_2.NgbActiveLabel;
exports.NgbRadioGroup = radio_2.NgbRadioGroup;
var NGB_RADIO_DIRECTIVES = [radio_1.NgbRadio, radio_1.NgbActiveLabel, radio_1.NgbRadioGroup];
var NgbButtonsModule = (function () {
    function NgbButtonsModule() {
    }
    NgbButtonsModule.forRoot = function () { return { ngModule: NgbButtonsModule, providers: [] }; };
    NgbButtonsModule = __decorate([
        core_1.NgModule({ declarations: NGB_RADIO_DIRECTIVES, exports: NGB_RADIO_DIRECTIVES }), 
        __metadata('design:paramtypes', [])
    ], NgbButtonsModule);
    return NgbButtonsModule;
}());
exports.NgbButtonsModule = NgbButtonsModule;
//# sourceMappingURL=radio.module.js.map


//////////////////
// WEBPACK FOOTER
// ./temp/buttons/radio.module.js
// module id = 11
// module chunks = 0